import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/true-size-of-lakes/page.tsx");
